export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Edycja zbiorcza",
    title: "Kalendarz zbiorczy",
    subtitle: "Zamykaj, otwieraj lub zmieniaj kilka jednostek naraz.",
  },
  actions: {
    close: {
      label: "Zamknij terminy",
      hint: "Zakłada blokadę ręczną z zachowaniem rezerwacji i synchronizacji.",
    },
    open: {
      label: "Otwórz terminy",
      hint: "Otwiera ponownie tylko wybrane dni, nie ruszając reszty blokady.",
    },
    price: {
      label: "Zmień cenę",
      hint: "Aktualizuje cenę za noc dla wybranych terminów i obiektów.",
    },
    minStay: {
      label: "Minimalny pobyt",
      hint: "Ustaw zbiorczo minimalną liczbę nocy dla każdego terminu.",
    },
  },
  microcopy: {
    close: "Blokada ręczna",
    open: "Otwarcie częściowe",
    price: "Cena za noc",
    minStay: "Minimalna liczba nocy",
  },
  step1: {
    title: "Co zastosować",
    hintEmpty: "Wybierz działanie, aby zacząć.",
  },
  step2: {
    title: "Gdzie zastosować",
    selectedCount: "Wybrano {selected} z {total}",
    selectVisible: "Widoczne",
    selectAll: "Wszystkie",
    clear: "Wyczyść",
    searchPlaceholder: "Szukaj obiektu…",
    empty: "Żaden obiekt nie pasuje do wyszukiwania.",
  },
  step3: {
    title: "Zakres i dni",
    datesInRange: "{count} termin w zakresie | {count} terminy w zakresie | {count} terminów w zakresie",
    from: "Od",
    to: "Do",
    presetAll: "Wszystkie",
    presetWeekdays: "Pn–Pt",
    presetWeekend: "Weekend",
  },
  step4: {
    closeReasonTitle: "Powód zamknięcia",
    availabilityTitle: "Dostępność",
    closeReasonHint: "Opcjonalnie. Zostanie zapisany razem z blokadą.",
    availabilityHint: "Sprzedaż jest zamknięta (stop-sell), a dostępność pozostaje bez zmian. Zmień to tylko wtedy, gdy chcesz.",
    closeCommentPlaceholder: "np. konserwacja lub użytek właściciela",
    availabilityPlaceholder: "Pokoje w sprzedaży (puste = bez zmian)",
    openAvailabilityHint: "Otwiera sprzedaż ponownie. Podaj, ile pokoi udostępnić (puste = bez zmian).",
    availabilityPlaceholderOpen: "Pokoje w sprzedaży",
  },
  ratePlan: {
    title: "Taryfa do zmiany",
    hint: "Ten typ ma kilka taryf. Wybierz, w których zastosować {target}. Taryfy pochodne dostosują się automatycznie.",
    targetPrice: "cenę",
    targetMinStay: "minimalny pobyt",
    default: "standardowa",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    multiUnitNote: "Zostanie zastosowana we wszystkich pokojach, które mają wybraną taryfę.",
    fallbackName: "Taryfa",
  },
  price: {
    title: "Nowa cena za noc",
    hint: "Zostanie zastosowana do wybranych terminów, jednostek i taryf.",
    mixedCurrencyWarning: "Wybierz tylko obiekty rozliczane w tej samej walucie.",
    placeholder: "Wartość",
    placeholderCurrency: "Wartość w {currency}",
    hintPercent: "Podnosi lub obniża cenę, którą każda noc już ma.",
    modeGroupLabel: "Rodzaj zmiany ceny",
    modeFixed: "Cena stała",
    modeFixedHint: "Ta sama kwota we wszystkie noce.",
    modePercent: "Procent",
    modePercentHint: "Od ceny każdej nocy z osobna.",
    modeAmount: "Kwota",
    modeAmountHint: "Dodać lub odjąć od każdej nocy.",
    amountPlaceholder: "np. 10",
    amountHint: "Dodaje się do obecnej ceny każdej nocy. Znak − obniża.",
    percentPlaceholder: "Np. 20",
    percentHint: "Każda noc jest przeliczana od własnej ceny. Znak − obniża ją (od {min} % do {max} %).",
    toggleSign: "Przełącz między podwyżką a obniżką",
    invalidPercent: "Wpisz procent od {min} % do {max} %, inny niż 0.",
  },
  minStay: {
    title: "Minimalny pobyt",
    hint: "Minimalna liczba nocy dla danego terminu.",
    placeholder: "np. 2",
  },
  summary: {
    empty: "Wybierz jednostki i zakres.",
    unitOne: "jednostka",
    unitMany: "jednostek",
    dateOne: "termin",
    dateMany: "terminów",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} gotowe do zastosowania.",
    nightOne: "noc",
    nightMany: "nocy",
    readyPriceFixed: "{propertyCount} {propertyLabel} · ustawi {price} {currency} w {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · podniesie cenę {dateCount} {nightLabel} o {amount} {currency}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · obniży cenę {dateCount} {nightLabel} o {amount} {currency}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · podniesie o {percent} % cenę {dateCount} {nightLabel}.",
    readyPriceDown: "{propertyCount} {propertyLabel} · obniży o {percent} % cenę {dateCount} {nightLabel}.",
  },
  footer: {
    cancel: "Anuluj",
    apply: "Zastosuj zmiany",
    applying: "Stosowanie…",
  },
  weekdays: {
    mon: { short: "P", long: "Poniedziałek" },
    tue: { short: "W", long: "Wtorek" },
    wed: { short: "Ś", long: "Środa" },
    thu: { short: "C", long: "Czwartek" },
    fri: { short: "P", long: "Piątek" },
    sat: { short: "S", long: "Sobota" },
    sun: { short: "N", long: "Niedziela" },
  },
  ownerBlockComment: "Zablokowane przez właściciela",
};
